module.exports = __webpack_public_path__ + "img/arrow-simple-down.3b739d78.svg";